"use strict";

const { createTypeLiteralNode } = require("typescript");

var advancedConfigCtrl = [
  "$uibModal",
  "Integration",
  "ReportConfig",
  "Department",
  "myTenant",
  "myDepartments",
  function ($uibModal, Integration, ReportConfig, Department, myTenant, myDepartments) {
    var _this = this;

    // TENANT VOOLKS CERTIFICATIONS
    this.myTenant = myTenant;
    _this.myTenant.load().then(() => {
        this.tenantId = _this.myTenant.get().id;
    })
    // this.voolksTenantId = "56fc21e402a3885f336d8d3f";
    // this.pampaTenantId = "60b0d8d8015d5f6b39cdbd57";
    // this.pampaEPTenantId = "5f159630815b7f852fbd1f6a";

    this.openConfig = function () {
      var options = {
        animation: true,
        controller: [
          "$uibModalInstance",
          "element",
          "form",
          "integrations",
          "isForValidator",
          "reportConfig",
          "$translate",
          function (
            $uibModalInstance,
            element,
            form,
            integrations,
            isForValidator,
            reportConfig,
            $translate
          ) {
            var _this = this;

            let findMe = (f, meId) => {
              return f.some(f1 => {
                if (f1.id == meId)
                  return true;
                if (f1.nodes) {

                  let found = findMe(f1.nodes, meId);
                  if (found && f1.type == "simplelist")
                    _this.meInSimpleList = true;
                  return found;
                }
                return false;
              });
            }
            _this.meInSimpleList=false;
            this.onRotateLabel = ()=>{
              let textWidth = document.createElement("canvas").getContext("2d").measureText(_this.element.name || _this.element.label).width;
              let rotatedHeight = Math.abs(textWidth * Math.sin(_this.element.reportConfig.rotateLabel* Math.PI / 180)) + Math.abs(18 * Math.cos(_this.element.reportConfig.rotateLabel* Math.PI / 180));
              _this.element.reportConfig.rotatedHeight = parseInt(rotatedHeight) +10;
            }
            form.pages.some(p=>findMe(p.fields,element.id));
            this.element = element;
            this.form = form;
            this.isForValidator = isForValidator;
            this.integrations = integrations;
            this.reportConfig = reportConfig;
            this.updateElement = false;

            this.element.reportConfig = element.reportConfig || {};
            this.maxHeightPhotoInForm = [
              { value: undefined, text: "Sin definir" },
              { value: "unset", text: "auto" },
              { value: "2.5", text: "2.5" },
              { value: "5", text: "5" },
              { value: "7.5", text: "7.5" },
              { value: "10", text: "10" },
              { value: "12.5", text: "12.5" },
              { value: "15", text: "15" },
              { value: "17.5", text: "17.5" },
              { value: "20", text: "20" },
            ];

            this.optTrueFalseUndefined = [
              { value: undefined, text: "Sin definir" },
              { value: true, text: "Si" },
              { value: false, text: "No" },
            ];

            this.optInterline = [
              { value: undefined, text: "Sin definir" },
              { value: "interline0px", text: "0" },
              { value: "interline1px", text: "1" },
              { value: "interline3px", text: "3" },
              { value: "interline5px", text: "5" },
              { value: "interline10px", text: "10" },
            ];

            this.optFontSize = [
              { value: undefined, text: "Sin definir" },
              { value: "font-size: 10px;", text: "10" },
              { value: "font-size: 12px;", text: "12" },
              { value: "font-size: 14px;", text: "14" },
              { value: "font-size: 16px;", text: "16" },
              { value: "font-size: 18px;", text: "18" },
              { value: "font-size: 20px;", text: "20" },
              { value: "font-size: 24px;", text: "24" },
              { value: "font-size: 28px;", text: "28" },
              { value: "font-size: 32px;", text: "32" },
              { value: "font-size: 36px;", text: "36" },
              { value: "font-size: 48px;", text: "48" },
            ];

            this.optTextAlign = [
              { value: undefined, text: "Sin definir" },
              {
                value: "text-align: center;justify-content: center;",
                text: "centrado",
              },
              {
                value: "text-align: left;justify-content: left;",
                text: "izquierda",
              },
              {
                value: "text-align: right;justify-content: right;",
                text: "derecha",
              },
            ];

            this.optHide = [
              { value: undefined, text: "Sin definir" },
              { value: "empty", text: "Cuando esta vacio" },
              { value: "always", text: "Siempre" },
              { value: "never", text: "Nunca" },
            ];

            this.optColSpan = [{ value: undefined, text: "Sin definir" }];

            if (reportConfig.gridOf == "grid-of-2")
              this.optColSpan.push({ value: "col-span-2", text: "2" });

            if (reportConfig.gridOf == "grid-of-3") {
              this.optColSpan.push({ value: "col-span-2", text: "2" });
              this.optColSpan.push({ value: "col-span-3", text: "3" });
            }
            if (reportConfig.gridOf == "grid-of-4") {
              this.optColSpan.push({ value: "col-span-2", text: "2" });
              this.optColSpan.push({ value: "col-span-3", text: "3" });
              this.optColSpan.push({ value: "col-span-4", text: "4" });
            }

            if (reportConfig.gridOf == "grid-of-5") {
              this.optColSpan.push({ value: "col-span-2", text: "2" });
              this.optColSpan.push({ value: "col-span-3", text: "3" });
              this.optColSpan.push({ value: "col-span-4", text: "4" });
              this.optColSpan.push({ value: "col-span-5", text: "5" });
            }
            if (reportConfig.gridOf == "grid-of-6") {
              this.optColSpan.push({ value: "col-span-2", text: "2" });
              this.optColSpan.push({ value: "col-span-3", text: "3" });
              this.optColSpan.push({ value: "col-span-4", text: "4" });
              this.optColSpan.push({ value: "col-span-5", text: "5" });
              this.optColSpan.push({ value: "col-span-6", text: "6" });
            }

            if (reportConfig.gridOf == "grid-of-7") {
              this.optColSpan.push({ value: "col-span-2", text: "2" });
              this.optColSpan.push({ value: "col-span-3", text: "3" });
              this.optColSpan.push({ value: "col-span-4", text: "4" });
              this.optColSpan.push({ value: "col-span-5", text: "5" });
              this.optColSpan.push({ value: "col-span-6", text: "6" });
              this.optColSpan.push({ value: "col-span-7", text: "7" });
            }


            this.optRowSpan = [{ value: undefined, text: "Sin definir" }];
            this.optRowSpan.push({ value: "row-span-2", text: "2" });
            this.optRowSpan.push({ value: "row-span-3", text: "3" });
            this.optRowSpan.push({ value: "row-span-4", text: "4" });
            this.optRowSpan.push({ value: "row-span-5", text: "5" });
            this.optRowSpan.push({ value: "row-span-6", text: "6" });

            this.newType = _this.element.type;
            this.excludedElementTypesForDisplay = ['simplelist', 'group', 'title', 'populate', 'duration'];
            this.elementsList = require("./../dashboardBuilderElements")($translate).filter(element => {
                return !this.excludedElementTypesForDisplay.includes(element.type);
            });
            
            this.onElementTypeChange = function () {
                // console.log("element before change", JSON.parse(JSON.stringify(_this.element)));
                if (_this.newType == _this.element.type) {
                    return;
                } else {
                    let newElement = _this.elementsList.find(
                        (el) => el.type == _this.newType
                    );
                    if (newElement) {
                        let updatedElementResult = _this.form.changeElementType(_this.element.id, newElement);

                        if (updatedElementResult) {
                            _this.element = updatedElementResult;
                            _this.newType = _this.element.type;
                            this.updateElement = true;
                        } else {
                            console.warn("Error: No se encontró el elemento con ID:", _this.element.id, "para cambiar su tipo.");
                        }
                    } else {
                        console.warn("New element type not found in elementsList:", _this.newType);
                    }

                }
            }

            this.close = function () {
                if (_this.updateElement) {
                    let updatedElement = _this.form.replaceElement(_this.element.id, _this.element);
                    if (updatedElement) {
                        _this.$close(_this.element);
                    }
                } else {
                    _this.$close(_this.element);
                }
            };
          },
        ],
        templateUrl:
          "dashboard-builder/advancedConfig/advancedConfigDirectiveModal.html",
        controllerAs: "ctrl",
        size: "xlg",
        windowClass: "dialog",
        bindToController: true,
        resolve: {
          isForValidator: function () {
            return _this.isForValidator;
          },
          element: function () {
            return angular.copy(_this.element);
          },
          form: function () {
            return _this.form;
          },
          integrations: function () {
            return Integration.find().$promise.then(function (integrations) {
              if (integrations.length == 0)
                return [];
              const dept= myDepartments.get().find(d=>d.id== _this.form.departmentId);
              // console.log('llamado 5 departments.get()')
              return integrations.filter(_in => (_in.clientId == undefined && _in.departmentId == undefined) || _in.clientId == dept.clientId || _in.departmentId == dept.id);
            });
          },
          reportConfig: function () {
            try {
              return _this.reportConfig;
            } catch (e) {
              return {};
            }
          },
        },
      };

      $uibModal.open(options).result.then(
        function (element) {
          _this.element.integration = element.integration;
          _this.element.reportConfig = element.reportConfig;
          _this.element.templateData = element.templateData;
          if (Array.isArray(element.metadata)) {
            element.metadata = element.metadata.reduce((lst, item) => {
              if (item.value != undefined && item.value != "") lst.push(item);
              return lst;
            }, []);
            if (element.metadata.length == 0) _this.element.metadata = null;
            else _this.element.metadata = [].concat(element.metadata);
          } else delete _this.element.metadata;
          return;
        },
        function () {
          return;
        }
      );
    };
  },
];

module.exports = function () {
  return {
    restrict: "E",
    scope: {
      element: "=",
      form: "=",
      reportConfig: '=',
      isForValidator: "=",
    },
    replace: true,
    controller: advancedConfigCtrl,
    controllerAs: "ctrl",
    bindToController: true,
    templateUrl:
      "dashboard-builder/advancedConfig/advancedConfigDirective.html",
  };
};
